import { getISOWeek, getMonth, getYear } from 'date-fns'
import groupBy from 'lodash/groupBy'

import type { DailyStat } from 'models/campaign-health-model'

const NUMERIC_FIELDS: (keyof DailyStat)[] = ['clicks', 'views', 'exchangeClicks', 'exchangeViews', 'exchangeCost']

// Collapse a group of daily stats into one row: date range + summed numeric fields.
const sumStats = (items: DailyStat[]): DailyStat => {
  const summed: any = { date: `${items[0].date} - ${items[items.length - 1].date}` }
  NUMERIC_FIELDS.forEach(key => {
    summed[key] = items.reduce((total, stat) => total + (stat[key] as number), 0)
  })
  return summed
}

// Group by year then period (month/isoWeek), summing each group; input is date-ordered so ascending key iteration keeps original order.
const groupDataByKey = (data: DailyStat[], getPeriod: (date: Date) => number): DailyStat[] =>
  Object.values(groupBy(data, stat => getYear(new Date(stat.date)))).flatMap(yearItems =>
    Object.values(groupBy(yearItems, item => getPeriod(new Date(item.date)))).map(sumStats),
  )

// `aggregation` is now passed in by the caller (from useWatch) instead of read via redux-form's formValueSelector.
export const getStatsData = (data: any, aggregation: any) => {
  switch (aggregation) {
    case 'monthly':
      return groupDataByKey(data, getMonth)
    case 'weekly':
      return groupDataByKey(data, getISOWeek)
    default:
      return data
  }
}
